import React from 'react';
import { v4 } from 'uuid';
import { Card, Tooltip } from '@mui/material';
import { Credential } from '@daml.js/utility-credential-v0/lib/Utility/Credential/V0/Credential';
import { DetailsRow } from '../../components/DetailsRow';
import { DetailsLayout } from '../../components/Table/DetailsLayout';
import { useCopyToClipboard } from '../../components/useCopyToClipboard';
import TemplateContract from '../../utils/TemplateContract';

interface CredentialDetailsProps {
  row: TemplateContract<Credential>;
}
interface ClaimProps {
  subject: string;
  property: string;
  value: string;
}

const Claim: React.FC<ClaimProps> = ({ subject, property, value }) => {
  const copyToClipboard = useCopyToClipboard();
  const onClick = () => {
    copyToClipboard(JSON.stringify({ subject, property, value }, null, 2));
  };

  return (
    <Tooltip title="Click to copy claims JSON object">
      <Card
        onClick={onClick}
        variant="outlined"
        sx={{
          cursor: 'pointer',
          pl: 1,
          pr: 1,
          pb: 1,
          mb: 1,
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <DetailsRow label="subject" value={subject} />
        <DetailsRow label="property" value={property} />
        <DetailsRow label="value" value={value} />
      </Card>
    </Tooltip>
  );
};
export const CredentialDetails: React.FC<CredentialDetailsProps> = ({ row }) => {
  const details = [
    {
      label: 'Issuer',
      value: row.payload.issuer,
    },
    {
      label: 'Holder',
      value: row.payload.holder,
    },
    {
      label: 'ID',
      value: row.payload.id,
    },
    {
      label: 'claims',
      value: row.payload.claims.map((c) => (
        <Claim key={v4()} subject={c.subject} property={c.property} value={c.value} />
      )),
    },
  ];
  return (
    <DetailsLayout>
      {details.map((detail) => (
        <DetailsRow key={detail.label} value={detail.value} label={detail.label} />
      ))}
    </DetailsLayout>
  );
};
